<template>
  <!-- 
파일 업로더 컴포넌트 - 모달에다가 썼을 때 파일 업로더 영역을 누르면 원 모달이 꺼지는 문제는 dyUploader를 모달 안에다 넣던가 모달에 persitent

ex) 사용예제 : v-if="fileHandler" 를 해줘야 파일 삭제후에 다시 올리려고 할 때도 새로고침 없이 재업로드가 가능해짐
    <CommonDYUploader v-if="fileHandler" v-model:modal-open="addFileModal"
                @upload-complete="addFileUploaded" table-name="contents" :subject-no="item?.contentsNo"
                field-name="fileTypedPk" :already-uploaded-count="alreadyFileCount" :max-files="5 - alreadyFileCount"
                upload-accept="image" title="첨부파일" @delete:all-file="formData.fileTypedPk = undefined 또는(좌항이나 우항 중 하나만 할 것, fileHandler끄는 건 우항만임) emit('requestApi'); fileHandler = false"
                :file-typed-pk="formData.fileTypedPk ? formData.fileTypedPk : item?.fileTypedPk!"
                @count:file="fileHandleChk">
              </CommonDYUploader>

    스크립트에서는------------
const addFileModal = ref(false)
const fileHandler = ref(true)

//파일 카운트 하려면 반드시 파일 핸들러를 같이 써줘야 하며, 핸들러의 count:file 이벤트로 받은 값을 할당해줘야 함
const alreadyFileCount = ref(0)

//실제로 백엔드에 보내줘야할 리퀘스트는 이것들 뿐으로 (이름은 바뀔 수 있음) 해당 타입들을 최종적으로 전송하려는 데이터에 추가
fileTypedPk?: string
fileTypedPkFileData?: DYFileFormData

const addFileUploaded = async (param: SendUploadFiles) => { //업로드 후에 처리해야 하는 것들
  fileHandler.value = false //핸들러의 파일을 올렸다가 지웠다가 했을때, 지우고 나서 다시 새로 올렸을때 변화 감지를 못해 핸들러에서 재요청 못하는 문제 방지 위함
  await nextTick(() => { //방금 올린것에 대한 처리를 위함임. 또한 핸들러를 쓰려면 async await을 해야만 방급 새로 올린 썸네일을 못 부르는 문제가 없음
    formData.value.fileTypedPk = param.fileTypedPk //db 등록용 fileTypedPk
    // tempProfileImage.value = param.url[0] //올리자마자 임시파일 이미지로 띄워야 하는 경우
    formData.value.fileTypedPkFileData = param.fileFormData //걍 필수로 올려줘야 함 백엔드용 데이터
  })
  fileHandler.value = true
}

const fileHandleChk = (count:number) => {
  alreadyFileCount.value = count
}

const cancelFile = () => { //필수적인것은 아님
  fileTypedPk.value = ''
  fileTypedPkFileData.value = undefined
}

업로드한 파일의 수정/삭제/랭크변경 기능등은 useDYFileUploader()에 있는 파일 관련 api들을 사용해 각 페이지별/컴포넌트별로 구현하면되나, 범용으로 사용할 경우 아래 참고 
!!!파일 핸들러 사용시 가장 주의할 점!!! - 폼을 통해 파일을 한 번 등록완료 하고, 다시 수정 모드의 폼으로 들어가서 해당 파일을 지운 후 새로 올리지는 않고 지우기만 한 상태로 
                                        다시 등록완료를 하면, 문제 발생. 원래 모든 파일을 지우면 백엔드에서는 해당 fileTypedPk의 필드값을 null로 비우는데(지우는 이유는 업로드 사실을 없애야 하는 경우가 있어서), 
                                        방금의 예시대로 할 경우 클라이언트에서 남아있던 이전 필드값을 다시 update시켜버리면서 그 순간부터 서로 다른 필드를 바라보게 된다.
                                        이 문제의 해결법은 2가지가 있는데, 하나는 prop데이터에 fileTypedPk가 있어도 수정모드에서 받지 않는것(어차피 fileTypedPk 자체는 폼에 띄워주는 용도가 아닌 내부값이기 때문)
                                        물론 무조건 없애서는 안되는데, 그러면 파일핸들러 등에서 알아낼 수 없게되므로, 부모의 데이터를 바로 쓸 수 있도록 하는 등의 별도조치가 필요하다.
                                        두 번째 방법은, 아래 예제처럼 파일 핸들러에서 delete:all-file이벤트가 발생한 경우 폼에서 fileTypedPk컬럼 값을 비워주는 것. 둘 중에 하나를 반드시 해야함
                                        또는 업데이트 할 때는 부모의 fileTypedPk컬럼값을 보내질 말던가..
                                        수정폼이 존재하지 않고 등록폼만 존재하는 경우에는 신경쓸 필요가 없음

                                        //delete-all-file 했을 때 fileHandler를 false로 해서 파일 핸들 모달자체를 없애야만 전달받은 프라퍼티를 초기화 가능
<CommonDYUploadedFileHandle v-if="fileHandler && (formData.fileTypedPk || item?.fileTypedPk)" 
        @delete:all-file="formData.fileTypedPk = undefined 또는(좌항이나 우항 중 하나만 할 것, fileHandler끄는건 우항만이고 추가로 껐다가 다시 켜야함) emit('requestApi'); fileHandler = false"
        :file-typed-pk="formData.fileTypedPk ? formData.fileTypedPk : item?.fileTypedPk!" @count:file="fileHandleChk">
</CommonDYUploadedFileHandle>
ㄴ (fileTypedPk || item?.fileTypedPk) 둘 다 필요한 이유는 전자는 해당 페이지에서의 폼데이터용, 후자는 부모나 디비에서 받은 기존 데이터로 전자는 신규 등록했을 때 바로 전달하기 위함이고, 후자는 기존 데이터가 있을 때 전달용

공용으로 사용하는 모달처럼 사용하는 경우 모달 토글이 될 때마다 반드시 fileTypedPkFileData 도 undefined 해줘야 함
fileTypedPk는 보통 기존 데이터에 없으면 초기화하지만 fileData는 수정후 다른 수정했을 때 초기화하지 않기 때문

백엔드에선 해당 apiController에서 아래 같은 형식으로 불러줌
참고로 fileTypedPkFileData 리퀘스트 값은 위의 fileTypedPkFileData를 폼으로 넘겼을때의 키명이 됨
if(\request('fileTypedPkFileData')) FileUploadUtility::uploadProcessForParentVue3($model, \request('fileTypedPkFileData'));
//앞으로는 fg를 안붙이고 넘버만 바로 fileTypedPk컬럼에 집어넣는 방식으로 사용한다고 헀을 때, 아래 메서드를 사용할 것
if(\request('fileTypedPkFileData')) FileUploadUtility::uploadProcessForParentVue3OnlyNumber($model, \request('fileTypedPkFileData'));

 -->
  <div class="uppy">
    <div class="hidden">
      <div ref="downloadIcon">
        <v-icon icon="fad fa-download" style="font-size: 100px;"></v-icon>
      </div>
    </div>
    <ClientOnly>
      <ModalDYDialog :dialog-control="modalOpen" :title="title" width="500px"
        @update:dialog-control="emit('update:modalOpen', $event)" :is-closable-by-back="isClosableByBack">
        <slot name="top"></slot>
        <Dashboard v-if="isAbleUploadCount && modalOpen && readyUppy" :uppy="uppy"
          :props="{ proudlyDisplayPoweredByUppy: false, width: 500, height: 400 }" />
        <slot name="bottom"></slot>
      </ModalDYDialog>
    </ClientOnly>
  </div>
</template>

<script setup lang='ts'>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner, faUpload } from '@fortawesome/pro-regular-svg-icons'
// import Korean from '@uppy/locales/lib/ko_KR'
// @ts-ignore - uppy ko_KR 타입 선언 미제공
import Korean from '@uppy/locales/lib/ko_KR'

// uppy 코어
import Uppy from '@uppy/core'
import Dashboard2 from '@uppy/dashboard'
import { Dashboard } from '@uppy/vue'
import XHR from '@uppy/xhr-upload'

import { faDownload } from '@fortawesome/pro-duotone-svg-icons'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { useDYFileUploader, type SendUploadFiles } from '~/modules/nuxt3-module-doyac/composables/dy-file-uploader'
import { useDYAppConfig } from '~/modules/nuxt3-module-doyac/composables/config'
import { useDYUserStore } from '~/modules/nuxt3-module-doyac/stores/user'
import { useDYMainStore } from '~/modules/nuxt3-module-doyac/stores/main'  // 이 줄 추가
import { notify } from '@kyvg/vue3-notification'
import { isNumber } from 'lodash-es'

library.add(faSpinner, faUpload, faDownload)

export type AllowUploadAccept = "cloudFlare" | "image" | "video" | "video&image" | "text" | "all" | "admin" | "naverTour" | "jpg&png" | "pdf"

const props = withDefaults(defineProps<{
  modalOpen: boolean
  /**
   * // 파일을 소유하게 되는 테이블 네임(fileTypedPk값이 들어가는 테이블)
   */
  tableName: string
  fieldName: string // 파일을 소유하게 되는 필드 네임(fileTypedPk값이 실제로 들어가는 컬럼)
  uploadAccept: AllowUploadAccept // 업로드 허용 가능 파일의 미메타입을 입력. 혹은 약속된 단어 사용. ex)image(모든 이미지), video(모든 비디오이나 사이트설정상 webm은 안됨), video&image(비디오+이미지), text(모든 텍스트), admin(모든 파일)
  /**
   * 이미 업로드된 파일 개수. 보통은 핸들러에서 count:file 이벤트로 수신받은 개수를 전달. 기존 업로드 개수를 영향주고 싶지 않은 경우는 0으로 넘길 것
   */
  alreadyUploadedCount: number
  /**
   * 값이 빌수있음(빈 경우 백엔드에서 사이트db를 기본으로 사용예정)
   */
  dbDomain?: string
  fileTypedPk?: string | number
  /**
   * 파일을 한번 임시 업로드한 상태에서 기존파일을 지우고 다시 업로드시키려면 reset이 필요
   */
  uploadReset?: boolean
  subjectNo?: number // 파일을 소유하게 되는 DB의 로우 주키. 이걸 제대로 넣어주지 않을 경우 기존 row 수정시 못가져옴
  title?: string //업로더 모달 헤더명
  localOnly?: boolean // 이미지인데도 클라우드 플레어등의 외부 업로드 하지 않을 파일의 경우 true로 줄 것
  // domain?: string // 지정안되면 자기 도메인. 특정 도메인을 지정해야 하는 경우 필요. ex)doyacinc : 이거 현재 구현 필요함(백엔드에서)
  maxSizeMb?: number // 지정안되면 10MB 고정. 10MB를 원할 경우 10MB라고 입력할것 >> 그리고, 클라우드 플레어 사양 한계로 100MB이상은 안됨
  maxFiles?: number // 지정안되면 5개 고정
  uploadPath?: string // E:/upFolder/도메인/upFolder/upFile 다음에 올경로만 적음. 앞뒤에 DIRECTORY_SEPARATE는 생략. 설정안하면 테이블네임과 필드네임의 기본값으로 업로드
  thumbNail?: [boolean | number, boolean | number, boolean | number, boolean | number] // 기본값은 썸네일 다 만듦. array(true를 입력하여 200/700/1920 으로 각각 생성 가능하며(s/m/l 의 기본 값), 원하는 수치를 직접 넣을 경우 해당으로 반영) ex) array(300,true,false) 로 하면 s사이즈를 300으로 만들고, m사이즈 기본설정으로 만들고 l사이즈는 만들지 않음
  thumNailOption?: [boolean, 'x' | 'y', number] // 시 배열로 받으며 3개의 파라미터를 가짐. $thumbNail파라미터가 배열일 때 혹은 true일 때만 반영 ($crop = 정사각형으로 자를지:기본값은 false / $controlPoint = 기준점 강제:기본값은 null, 가로면 x, 세로면 y / $quality = 숫자를 입력 50이 기본값)* 기본적으로 s/m/l썸네일 말고도 t버전의 썸네일도 생성되게 된다. 최대 1100width에 x축 기준으로 계산되며 퀄리티 7%로 설정
  returnThumbanil?: boolean
  autoCloseOnComplete?: boolean
  isClosableByBack?: boolean
  uniqueId?: number //보통은 쓸 일 없겠으나 디자인 커스터마이즈 처럼 특수한 경우에 필요
}>(), {
  localOnly: () => false,
  maxSizeMb: () => 10,
  maxFiles: () => 5,
  thumbNail: () => [true, true, true, true],
  thumNailOption: () => [false, 'x', 80],
  returnThumbanil: () => true,
  autoCloseOnComplete: () => true,
  isClosableByBack: () => false
})

const emit = defineEmits<{
  (e: 'update:modalOpen', value: boolean): void,
  (e: 'update:uploadReset', value: boolean): void,
  /**
   * 파일업로드가 완료되어, 여기서 temp Image등의 썸네일이나 fileUrl은 여기서 처리하고, fileFormData는 업로드용 데이터로 백엔드로 그대로 넘기면 된다(폼데이터 등에 담아서)
   */
  (e: 'upload-complete', v: SendUploadFiles): void,
  /**
   * 임시 업로드된 파일들을 다 취소하는 경우
   */
  (e: 'cancel-complete'): void
}>()

const { basePath, API_BASE_URL } = useDYAppConfig()
const userStore = useDYUserStore()
const { getUploadedFiles } = useDYFileUploader()

// --------------------- 데이터

// const hasInit = ref(false)
const rank = ref(0)
const tempUploadFiles = ref<string[]>([])
const uplodedFileTypedPk = ref('')

/**
 * 업로드 가능 파일 개수가 초과했는지
 */
const isAbleUploadCount = ref(true)

/**
 * 이번에 새로 올린 파일들
 */
const currentFileUrls = ref<string[]>([])

/**
 * 업로드가 성공적으로 완료된 상태인지. 모달 닫힐 때 cancelAll()로 인해 cancel-complete가 불필요하게 emit되는 것을 방지
 */
const uploadCompleted = ref(false)

const computedUploadAccept = computed(() => {
  switch (props.uploadAccept) { // admin타입의 경우 png 업로드 불가. 압축률이 떨어져서? 인듯
    case 'cloudFlare': return ['.jpg', '.gif', '.webp', '.jpeg', '.png'] //클라우드 플레어에서 허용하는 이미지 파일들
    case 'naverTour':
    case 'jpg&png':
      return ['.jpg', '.jpeg', '.png']
    case 'image': return ['image/*']
    case 'video': return ['video/*', 'audio']
    case 'video&image': return ['video/*', 'image/*', 'audio/*']
    case 'text': return ['text/*', '.ppt', '.pptx', 'application/xml']
    case 'all': return ['image/*', 'video/*', 'text/*', '.zip', 'application/pdf', '.xml', '.xlsx']
    case 'admin': return ['image/*', 'video/*', 'text/*', '.zip', 'application/pdf', '.procreate', '.psd', '.brush', '.webp', '.xml', '.xlsx', '.clip']
    // 2026-04-29 PDF 전용 — 강의노트(PDF) 결합 기능을 위한 PDF only 업로드
    case 'pdf': return ['application/pdf']
  }
  return ['image/*']
})

//부모 데이터가 아직 없는 경우에도 업로드시 동일한 유니크 아이디로 올라가서 최종 업데이트 했을 때 한번에 동일한 부모를 바라보게 되어야만 함
const uniqueId = ref(props.uniqueId ? props.uniqueId : Math.random())

// --------------------- 컴퓨티드

// ---------------------- 메서드

const makeFormData = (rankOverride?: number) => {
  const formData: Record<string, any> = {
    dbDomain: props.dbDomain,
    tableName: props.tableName,
    fieldName: props.fieldName,
    uniqueId: uniqueId.value,
    'thumbNail[]': props.thumbNail,
    'thumNailOption[]': props.thumNailOption,
    localOnly: props.localOnly,
  }

  // 값이 있을 때만 추가 (null, undefined, 빈 문자열 제외)
  if (props.fileTypedPk) {
    formData.fileTypedPk = props.fileTypedPk
  }

  // undefined나 null인 경우 방지 위함
  if (props.subjectNo) Object.assign(formData, { subjectNo: props.subjectNo })
  const effectiveRank = isNumber(rankOverride) ? rankOverride : (rank.value + 1)
  Object.assign(formData, { rank: effectiveRank })
  if (props.uploadPath) Object.assign(formData, { uploadPath: props.uploadPath })
  // console.log('formData', formData)
  return formData
}

const pictureDownloadIcon = () => {
  const dropArea = document.querySelectorAll('.uppy-Dashboard-AddFiles-list')
  if (dropArea) {
    dropArea.forEach((item) => {
      item.innerHTML = '<div class="w-full h-full flex items-center justify-center">' + downloadIcon.value?.innerHTML + '</div>'
    })
  }
}

// ----------- 훅

let uppy: any
const readyUppy = ref(false)

onMounted(() => {
  uppy = new Uppy({
    locale: Korean,
    onBeforeFileAdded: () => true, //동일 파일 중복 업로드 허용해주는 것. 이거 있어야 관리자들이 편함. 하나 파일 올리고, 해당 파일의 내용을 수정하고 이름만 바꾸고 다시 업로드해도 허용
    restrictions:
      { maxFileSize: props.maxSizeMb * 1000000, allowedFileTypes: computedUploadAccept.value, maxNumberOfFiles: props.maxFiles },
  }).use(
    XHR, { endpoint: `${API_BASE_URL}/api/file-uploads`, headers: { authorization: `${userStore.accessToken}`, accept: 'application/json' }, limit: 1 } // basePath가 '/'인 경우 이중 슬래시(//mer/...)가 되어 브라우저가 mer를 도메인으로 해석하는 문제 방지
  ).use(
    Dashboard2, { proudlyDisplayPoweredByUppy: false }
  ).on('files-added', (files) => {
    // 파일명을 기준으로 정렬하여 일관된 랭크 부여
    const sorted = [...files].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
    let startRank = (props.alreadyUploadedCount || 0)
    sorted.forEach((f) => {
      startRank += 1
      uppy.setFileMeta(f.id, makeFormData(startRank))
    })
  })
    .on('file-added', (file) => { //파일의 메타데이터를 추가해 내가 원하는대로 백엔드에서 핸들링하기 위함
      // 단일 추가 시에도 순차 랭크를 부여
      rank.value = (rank.value || (props.alreadyUploadedCount || 0)) + 1
      uppy.setFileMeta(file.id, makeFormData(rank.value))
    }).on('upload-error', (file, error, response) => { //파일의 메타데이터를 추가해 내가 원하는대로 백엔드에서 핸들링하기 위함
      if (error.message) notify({ type: 'error', text: error.message })
    }).on('upload-success', (file, response) => {
      if (response) {
        const returnUrl = props.returnThumbanil ? (response.body?.fileThumbnail ?? response.body?.fileUrl) : (response.body?.fileUrl ?? response.body?.fileThumbnail)

        tempUploadFiles.value.push(returnUrl)
        currentFileUrls.value.push(response.body?.fileUrl)

        if (isNumber(props.fileTypedPk)) {
          uplodedFileTypedPk.value = props.fileTypedPk ? 'fg' + props.fileTypedPk : 'fg' + response.body?.groupNo
        } else {
          uplodedFileTypedPk.value = props.fileTypedPk && (props.fileTypedPk.startsWith('fg') || props.fileTypedPk.startsWith('fi')) ? props.fileTypedPk : 'fg' + response.body?.groupNo
        }
      }
    }).on('complete', (result) => { //모든 파일 업로드 성공시 
      if (result.failed.length < 1) {
        uploadCompleted.value = true
      }
      emit('upload-complete', {
        url: tempUploadFiles.value,
        currentFileUrls: currentFileUrls.value,
        fileTypedPk: uplodedFileTypedPk.value,
        fileFormData: { fieldName: props.fieldName, fileTypedPk: uplodedFileTypedPk.value }
      })
      if (result.failed.length < 1 && props.autoCloseOnComplete) emit('update:modalOpen', false)
      currentFileUrls.value = [] //업로드가 전부 끝나고 emit도 발생하고 나면 이번에 등록한 파일 배열은 다시 초기화
    }).on('cancel-all', () => {
      uniqueId.value = props.uniqueId ? props.uniqueId : Math.random()
      // 전체 리셋 되었다고 이 단계에서 실제 서버에 올라간 임시 파일을 지우진 않을 것이며, 단지 유니크 아이디만 바꿈
      // 이렇게 하면, 이 상태에서 다시 파일을 등록하려 했을 때, 새로운 부모 그룹을 만들것이고, 결국 할당되지 못한 이전 부모 그릅과 파일들은 지워질 것임
      if (!uploadCompleted.value) {
        emit('cancel-complete')
      }
    })

  // uppy 초기화 완료 표시
  nextTick(() => {
    readyUppy.value = true
  })
})

if (import.meta.client) {
  watch(() => props.uploadReset, async (val) => {
    if (val && uppy) {
      uppy.cancelAll()
      tempUploadFiles.value = []
      rank.value = 0
      nextTick(() => {
        emit('update:uploadReset', false)
      })
    }
  })
}

const downloadIcon = ref<HTMLElement>()
if (import.meta.client) {
  watch(() => props.modalOpen, async (val) => {
    if (val) {
      // 모달이 열릴 때 로딩 상태 해제 (수정 모드에서 로딩이 남아있는 경우 방지)
      const mainStore = useDYMainStore()
      if (mainStore.isLoading) {
        mainStore.isLoading = false
      }

      // uppy가 준비될 때까지 대기
      if (!uppy || !readyUppy.value) { //수정모드일때 uppy가 좀 늦게 열리면서 로딩이 뜨는 문제가 발생됨
        // uppy가 아직 준비되지 않았다면, 준비될 때까지 대기
        await new Promise<void>((resolve) => {
          const checkUppy = () => {
            if (uppy && readyUppy.value) {
              resolve()
            } else {
              setTimeout(checkUppy, 10)
            }
          }
          checkUppy()
        })
      }

      // 모달이 열릴 때마다 변경된 maxFiles를 uppy에 반영 (동적으로 남은 개수 업데이트)
      uppy.setOptions({
        restrictions: {
          maxFileSize: props.maxSizeMb * 1000000,
          allowedFileTypes: computedUploadAccept.value,
          maxNumberOfFiles: props.maxFiles
        }
      })

      if (props.maxFiles < 1) {
        isAbleUploadCount.value = false
        nextTick(() => {
          emit('update:modalOpen', false)
          notify({ type: 'warn', text: '이미 최대 업로드 개수에 도달하였습니다. 신규 업로드를 하시려면 기존 파일을 삭제해주세요' })
        })
      } else {
        isAbleUploadCount.value = true
      }

      // uppy가 준비된 후에만 스타일 적용
      if (uppy) {
        await nextTick()
        const dashboardInner = document.querySelectorAll('.uppy-Dashboard-inner')
        if (dashboardInner) {
          dashboardInner.forEach((item) => {
            if (item instanceof HTMLElement) {
              item.style.backgroundColor = '#c8dadf'
              item.style.padding = '10px'
              if (item.firstElementChild instanceof HTMLElement) item.firstElementChild.style.outline = '2px dashed #92b0b3'
            }
          })
        }

        pictureDownloadIcon()
      }

      setTimeout(() => { //여러 방지책을 걸었음에도 로딩효과가 계속 남아있는 경우가 있어서 추가
        mainStore.isLoading = false
      }, 500)
    } else {
      // 모달이 닫힐 때 내부 상태 초기화
      if (uppy) uppy.cancelAll()
      tempUploadFiles.value = []
      currentFileUrls.value = []
      rank.value = 0
      uplodedFileTypedPk.value = ''
      uploadCompleted.value = false
    }
  })
}
</script>

<style>
/* 이게 없으면 사용자가 자의적으로 취소하고 새로 파일 업로드 가능 */
.uppy-StatusBar-actionBtn--done {
  display: none;
}
</style>